export { AuthIframe } from './AuthIframe.component';
